module.exports = __webpack_public_path__ + "img/AU.b28b7abb.png";